/**
 * Класс оборачивает некоторые запросы к статистике (flume & xlogr) из JavaScript
 *
 * @class
 */
var Stat = function ($) {

    /**
     * Выполняет асинхронный кросдоменный GET запрос, используя 1px <img>
     *
     * @param {String} url
     * @param {Object<String>} data
     */
    function ajaxImageGet(url, data) {

        var requestUrl = url
            + (url.indexOf('?') >= 0 ? '&' : '?')
            + Params.stringify(data);

        $('<img />')
            .attr({
                src: requestUrl,
                width: 1,
                height: 1
            })
            .css({
                position: 'absolute',
                left: '-9999em',
                top: '-9999em'
            })
            .load(function () {
                $(this).remove();
            })
            .error(function () {
                $(this).remove();
            })
            .appendTo('body');
    }

    /**
     * @constructor
     * @param {{statUrl, flumeStatUrl}} parameters
     */
    function Stat(parameters) {
        if (parameters.statUrl) {
            this.xlogrUrl = decodeURIComponent(parameters.statUrl);
        }
        if (parameters.flumeStatUrl) {
            this.flumeUrl = decodeURIComponent(parameters.flumeStatUrl);
        }
    }

    Stat.prototype = {

        /**
         * @param {String} type
         * @param {String} event
         * @param {p1, p2, p3, p4, p5, p6, p7, p8, tx} args
         * @private
         */
        _xlogrLog: function (type, event, args) {
            if (!this.xlogrUrl) {
                return;
            }

            var data = $.extend({
                'format': 'slim',
                't': type,
                'e': event
            }, args);

            ajaxImageGet(this.xlogrUrl, data);
        },

        /**
         *
         * @param {String} type
         * @param {String} event
         * @param {Object<String>} args "narg_" prefix for number arguments; "sarg_" prefix for string arguments
         * @private
         */
        _flumeLog: function (type, event, args) {
            if (!this.flumeUrl) {
                return;
            }

            var data = $.extend({
                'type': type,
                'name': event
            }, args);

            ajaxImageGet(this.flumeUrl, data);
        },

        /**
         *
         * @param {String} type
         * @param {String} event
         * @param {xlogr, flume} [args]
         * @private
         */
        _track: function (type, event, args) {
            args = args || {};
            Logger.log("Stat.track: t=%s, e=%s", type, event, args);
            this._xlogrLog(type, event, args.xlogr || {});
            this._flumeLog(type, event, args.flume || {});
        }
    };

    Stat.prototype.trackJsLoaded = function () {
        this._track('app:load', 'JsLoad');
    };

    Stat.prototype.trackSocialLoaded = function () {
        this._track('app:load', 'SocialLoad')
    };

    Stat.prototype.trackPlayerRuns = function (player) {
        this._track('app:load', 'PlayerRuns', {
            xlogr: {p1: player},
            flume: {sarg_player: player}
        });
    };

    Stat.prototype.trackFlashEmbedFail = function (message) {
        this._track('app:error', 'EmbedSWF', {
            xlogr: {p1: '???', p2: message},
            flume: {sarg_v: '???', sarg_m: message}
        });
    };

    // noinspection JSUnusedGlobalSymbols used in JSSigPreloader
    Stat.prototype.trackPreloaderLoaded = function () {
        this._track('app:load', 'PreloaderLoad')
    };

    // noinspection JSUnusedGlobalSymbols used in JSSigPreloader
    Stat.prototype.trackSwfPreload = function () {
        this._track('app:load', 'SwfPreload')
    };

    // noinspection JSUnusedGlobalSymbols used in JSSigPreloader
    Stat.prototype.trackSwfLoadError = function () {
        this._track('app:error', 'SwfLoadError')
    };

    // noinspection JSUnusedGlobalSymbols used in FPCrashReporter
    Stat.prototype.trackFlashCrash = function (embedTime) {
        var delta = (new Date()).getTime() - embedTime;
        this._track('app:error', 'FPCrash', {
            xlogr: {p1: delta},
            flume: {narg_t: delta}
        });
    };

    return Stat;

}(jQuery);
